import { render, staticRenderFns } from "./PluginPlausible.vue?vue&type=template&id=a6ba9392"
import script from "./PluginPlausible.vue?vue&type=script&lang=js"
export * from "./PluginPlausible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ba9392')) {
      api.createRecord('a6ba9392', component.options)
    } else {
      api.reload('a6ba9392', component.options)
    }
    module.hot.accept("./PluginPlausible.vue?vue&type=template&id=a6ba9392", function () {
      api.rerender('a6ba9392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginPlausible.vue"
export default component.exports